<template>

    <div class="">
        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
            <div class="clearfix row py-2 mb-2 no-margin">
                <div class="col-md-12 no-margin p-0">
                    <div class="row d-flex justify-content-end no-margin">
                        <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning"
                            @click="previewOrDownload(0)">Preview Report</b-button>
                        <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning"
                            @click="resetView()">Reset Selection</b-button>
                        <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning"
                            @click="previewOrDownload(1)">Download Report (Excel)</b-button>
                    </div>
                </div>
            </div>

            <div v-if="this.is_grid_diplayable">
                <common-list :checkbox="checkbox" :appended_column="appended_column" :key="list_key"
                    :company_options="company_options" :employees="custom_list" :default_column="default_column"
                    :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>

            </div>


            <div class="" v-if="!this.is_grid_diplayable && this.is_preview">
                <h4>Long Service Leave Report</h4>
                <div class="card-body container px-0 ">
                    <div class="row justify-content-center no-margin">
                        <div class="col-sm-12 px-0">
                            <b-overlay :show="showoverlay_list" rounded="sm">
                                <table class="table dataTable border">
                                    <thead>
                                        <tr class="table-head">
                                            <td>Name</td>
                                            <td>Employee Code</td>
                                            <td>Joining Date</td>
                                            <td>Service Length<br>(Months)</td>
                                            <td>Allow Tier<br>(Months)</td>
                                            <td>Allowed Leaves</td>
                                            <td>Consumed Leaves</td>
                                            <td>Remaining Leaves</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in preview_data" :key="index">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.employee_code }}</td>
                                            <td>{{ item.joining_date }}</td>
                                            <td>{{ item.service_months }}</td>
                                            <td>{{ item.minimum_required_months }}</td>
                                            <td>{{ item.leaves_entitled }}</td>
                                            <td>{{ item.leaves_enjoyed }}</td>
                                            <td>{{ item.leaves_remaining }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="preview_data.length === 0" class="list-no-data">No records found.</div>
                            </b-overlay>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>


<script>
export default {

    mounted() {

    },
    props: [],
    data() {
        const now = new Date()
        return {
            /**Child Component property data */
            selected: [],
            checkbox: 1,
            list_key: 0, /* Component Key */
            custom_list: [],  /* Data List */
            default_column: ['name', 'phone', 'email', 'jobposition', 'department', 'branch'],
            appended_column: [],
            primary_key: 'employee_id',
            company_options: [],
            tmp_custom_list: [],
            employee_ids: [],
            preview_data: [],
            is_preview: 0,
            is_grid_diplayable: 1,
            showoverlay: false,
        }
    },
    methods: {
        resetView: function () {
            this.is_grid_diplayable = 1;
            this.preview_data = '';
            this.selected = [];
            this.list_key += 1;

        },
        listReturn: function (data) {
            this.selected = data.selected;
        },

        getEmployeesList: function () {

            if (!this.checkNet()) return false;
            let currentObj = this;
            this.showoverlay = true;
            axios.get(this.$api_url + '/employee/list', {

            }).then(function (response) {

                /* Assingning the list */
                this.tmp_custom_list = response.data.employee_data;
                this.company_options = response.data.options;

                this.custom_list = this.tmp_custom_list;
                this.showoverlay = false;

                this.list_key = this.list_key + 1;
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },
        previewOrDownload: function (flg) {
            if (!this.checkNet()) return false;

            if (typeof this.selected == 'undefined')
                this.$bvToast.toast("Please select employee(s) to generate report", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
            else if (this.selected.length == 0)
                this.$bvToast.toast("Please select employee(s) to generate report", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });

            else {
                let currentObj = this;
                if (flg == 0) {
                    this.$bvToast.toast('We are generating the report, this may take a while, please hold tight.', {
                        title: `Info`,
                        variant: 'info',
                        solid: true
                    });
                }
                else if (flg == 1) {
                    this.$bvToast.toast('We are downloading the report, this may take a while, please hold tight.', {
                        title: `Info`,
                        variant: 'info',
                        solid: true
                    });
                }

                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_ids', JSON.stringify(this.selected));
                formData.append('is_export', flg);

                axios.post(this.$api_url + '/leave-attendance/longservice-leave/report', formData, {
                    responseType: flg === 1 ? 'blob' : 'json'
                })
                    .then(function (response) {
                        this.showoverlay = false;

                        if (flg === 0) {
                            this.preview_data = response.data;
                            this.is_preview = 1;
                            this.is_grid_diplayable = 0;
                        } else if (flg === 1) {
                            this.global_download_file_content(response);
                        }
                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay = false;
                        currentObj.serverError(error);
                    }.bind(this));
            }
        },
    },
    created: function () {
        this.getEmployeesList();
    }
}
</script>
